import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {StaffDocument, StaffDocumentSearchParams, StaffDocumentType} from '@accounting/_common/models/staff-document.models';

export const CheckState = createAction(
    '[StaffDocument] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: StaffDocument[], documentType: StaffDocumentType | 'CROSS' } }>()
);

export const CheckStateSuccess = createAction(
    '[StaffDocument] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: StaffDocument[], documentType: StaffDocumentType | 'CROSS' } }>()
);

export const LoadList = createAction(
    '[StaffDocument] Load List',
    props<{ payload: { loading: DahLoadingType, documentType: StaffDocumentType | 'CROSS', clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[StaffDocument] Load List Success',
    props<{ payload: { items: StaffDocument[], pagination: DahPaginationModel, documentType: StaffDocumentType | 'CROSS', clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[StaffDocument] Load List Failure',
    props<{ payload: { error: HttpErrorResponse, documentType: StaffDocumentType | 'CROSS' } }>()
);

export const SetPagination = createAction(
    '[StaffDocument] Set Pagination',
    props<{ payload: { next: boolean, documentType: StaffDocumentType | 'CROSS' } }>()
);

export const SetFilter = createAction(
    '[StaffDocument] Set Filter',
    props<{ payload: { filter: StaffDocumentSearchParams, documentType: StaffDocumentType | 'CROSS' } }>()
);

export const SetLoading = createAction(
    '[StaffDocument] Set Loading',
    props<{ payload: { loading: DahLoadingType, documentType: StaffDocumentType | 'CROSS' } }>()
);

export const SetItemsLoading = createAction(
    '[StaffDocument] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean, documentType: StaffDocumentType | 'CROSS' } }>()
);

export const UpdateItemSuccess = createAction(
    '[StaffDocument] Update Item Success',
    props<{ payload: { item: StaffDocument, documentType: StaffDocumentType | 'CROSS' } }>()
);

export const DeleteItem = createAction(
    '[StaffDocument] Delete Item',
    props<{ payload: { item: StaffDocument, documentType: StaffDocumentType | 'CROSS' } }>()
);

export const DeleteItemSuccess = createAction(
    '[StaffDocument] Delete Item Success',
    props<{ payload: { item: StaffDocument, documentType: StaffDocumentType | 'CROSS' } }>()
);

export const DeleteItemFailure = createAction(
    '[StaffDocument] Delete Item Failure',
    props<{ payload: { item: StaffDocument, documentType: StaffDocumentType | 'CROSS' } }>()
);

export const SetInitialState = createAction(
    '[StaffDocument] Set Initial State'
);
